import ArchivedFundApplications from "src/components/feature/ArchivedFundApplications";

const ArchivedFundApplicationsPage = () => {
  return <ArchivedFundApplications />;
};

export default ArchivedFundApplicationsPage;
